var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScraperapiLogoNoText2026(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    rx: 20,
    fill: "#7A2EFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.5117 123.731H100.334C105.883 123.731 111.263 120.704 113.953 115.828C116.811 110.952 116.811 104.898 113.953 100.022C111.095 95.1461 105.883 92.1195 100.334 92.1195H91.2544H82.0068C76.2903 92.2878 70.9097 89.2612 68.0514 84.3852C65.1931 79.5088 65.1931 73.2874 68.0514 68.4114C70.9097 63.5352 76.2903 60.5086 82.0068 60.6768H115.971",
    stroke: "white",
    strokeWidth: 4.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.602 45.2035H82.2131C70.9478 45.0354 60.5234 50.9204 54.8067 60.6727C49.09 70.4251 49.2582 82.3631 54.8067 92.1155C60.3553 101.868 70.9478 107.753 82.2131 107.585H95.6643",
    stroke: "white",
    strokeWidth: 4.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7773 139.038H100.166C117.484 139.038 131.272 125.082 131.272 107.931C131.272 90.7805 117.316 76.8245 100.166 76.8245H86.715",
    stroke: "white",
    strokeWidth: 4.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M124.888 69.7507C129.81 69.7507 133.799 65.7608 133.799 60.8391C133.799 55.9173 129.81 51.9275 124.888 51.9275C119.966 51.9275 115.977 55.9173 115.977 60.8391C115.977 65.7608 119.966 69.7507 124.888 69.7507Z",
    stroke: "white",
    strokeWidth: 4.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1105 132.974C58.0321 132.974 62.0218 128.984 62.0218 124.062C62.0218 119.14 58.0321 115.15 53.1105 115.15C48.1889 115.15 44.1992 119.14 44.1992 124.062C44.1992 128.984 48.1889 132.974 53.1105 132.974Z",
    stroke: "white",
    strokeWidth: 4.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScraperapiLogoNoText2026);
export default __webpack_public_path__ + "static/media/scraperapi-logo-no-text-2026.63185bb5e740d8d4bb0cb28da71d6f0a.svg";
export { ForwardRef as ReactComponent };